
import { defineComponent, PropType, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import type { OwnerIntegrationInfo } from '@/types/integrations';

// Re-exported so existing imports keep working during the migration to
// `@/types/integrations`.
export type { OwnerIntegrationInfo };

export default defineComponent({
  name: 'IntegrationOwnerBadge',

  props: {
    ownerIntegration: {
      type: Object as PropType<OwnerIntegrationInfo | null>,
      default: null,
    },
  },

  setup(props) {
    const { t } = useI18n();

    const tooltipLabel = computed(() => {
      if (!props.ownerIntegration) return '';
      if (!props.ownerIntegration.is_active) {
        return t('integrationOwnerBadge.uninstalled', {
          name: props.ownerIntegration.name,
        });
      }
      return t('integrationOwnerBadge.tooltip', {
        name: props.ownerIntegration.name,
      });
    });

    return { t, tooltipLabel };
  },
});
